export default "__VITE_ASSET__Bn0azeK4__"